<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import Select2 from 'vue3-select2-component';
import flatPickr from "vue-flatpickr-component";
import DataTable from 'datatables.net-vue3';
import Swal from "sweetalert2";
import moment from 'moment';


export default {
  page: {
    title: "Starter",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "My Enquiry",
      items: [
        {
          text: "My Enquiry",
          active: true,
        },
      ],
    date: { enableTime: true,
            dateFormat: "Y-m-d H:i:S",
            disable: [
                // Disable weekends
                function(date) {
                    return (date.getDay() === 0 || date.getDay() === 6);
                },
                // Disable specific dates
                new Date(),
                // new Date().fp_incr(-6),
                // "2022-03-10",
                // "2022-03-04" 
            ],
            minDate: new Date().fp_incr(7),
            // minDate: new Date().fp_incr(0),
            // maxDate: new Date().fp_incr(6),
          },
      ListUser:[],
      compnyDetail:[],
      OrgData:[],
        company_name:'',
        roc:'',
        address:'',
        organization:'',
        organization_id:'',
        bankname:'',
        accnumber:'',
        isLoadingapi: false,
        loadsubmitOrder:false,

        error_show_category:false,
        error_text_category:'',
        error_text_brand:'',
        error_show_brand:false,
        error_text_address:'',
        error_show_address:false,
        error_text_date:'',
        error_show_date:false,
        error_text_image:'',
        error_show_image:false,
        error_text_model:'',
        error_show_model:false,

        Myreferal:'',
      //form
        fullname:'',
        VoucherSeen:true,
        VoucherSeenAdmin:true,
        newpassword:'',
        newpasswordre:'',
        oldpassword:'',
        category:'',
        proceedaxious:'',
        categoryList:[
                {
                    "text": "Laptop",
                    "id": 1
                },
                {
                    "text": "Macs",
                    "id": 176208
                },
                {
                    "text": "Others",
                    "id": 176209
                },
                {
                    "text": "Smartphones",
                    "id": 38112
                },
                {
                    "text": "Tablets",
                    "id": 176207
                },
                {
                    "text": "Watches",
                    "id": 38522
                }
            ],
            brand:'',
            brandList:[],
            modelList:[{'id':'0','text': "Please Select Brand" }],
            quantityA:'1',
            EnquiryList:[],
            EnquiryListAdmin:[],  
            usercurrent:localStorage.getItem('name'),
            cloudFrontURL: process.env.VUE_APP_BUCKET,
    };
  },
  methods: {
     format_date(value){
         if (value) {
           return moment(String(value)).format('MMM Do YY(h:mm a)')
          }
      },
    close_enquiry(id){
        console.log("test");
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        // axios.get(process.env.VUE_APP_API_BASEURL+'voucher/brand')
        axios.post(process.env.VUE_APP_API_BASEURL+'enquiry/close/'+id)
        .then(response => {
            if (response) {
                console.log('succes');
            } else {
                console.log('error');
            }
        })
            .catch(error => {
                this.messageBag = [error.error];
        });
    },
    

    getBrand(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        // axios.get(process.env.VUE_APP_API_BASEURL+'voucher/brand')
        axios.get(process.env.VUE_APP_API_BASEURL+'device/brand')
        .then(response => {
            if (response) {
                this.brandList=response.data;
            } else {
                console.log('error');
            }
        })
            .catch(error => {
                this.messageBag = [error.error];
        });
    },
    CategoryOnChangeSelected(){

        if(this.brand != '0'||this.brand == null){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            if(this.brand == null||this.brand == ''){
                this.sqlUrl = process.env.VUE_APP_API_BASEURL+'devicenew/brand/'+this.category;
                
            }else{
                this.sqlUrl = process.env.VUE_APP_API_BASEURL+'devicenew/brand/'+this.category;
                // this.sqlUrl = process.env.VUE_APP_API_BASEURL+'voucher/brand/' + this.brand+'/'+this.category;
            }
            axios.get(this.sqlUrl)
            .then(response => {
                if (response) {
                    // this.brandList  = [{'id':'0','text': "Please select "+ this.brand +" model " }].concat(response.data);
                    this.brandList  = (response.data);
                } else {
                    console.log('error');
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
            });
        }
    },

    ModelSelected(e){
            this.model_='0';
            if(e.target.value != ''){
                if(this.category == '')
                {
                    this.categorySend = 'NONE';
                }else{
                    this.categorySend = this.category;
                }
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')

                if(this.brand == null||this.brand == ''){
                    // this.sqlUrl = process.env.VUE_APP_API_BASEURL+'voucher/model/'+this.category;
                    this.sqlUrl = process.env.VUE_APP_API_BASEURL+'device/brand/'+this.category;
                }else{
                    // this.sqlUrl = process.env.VUE_APP_API_BASEURL+'voucher/model/' + this.brand+'/'+this.category;
                    this.sqlUrl = process.env.VUE_APP_API_BASEURL+'device/brand/' + this.brand+'/'+this.category;
                }

                axios.get(this.sqlUrl)
                .then(response => {
                    if (response) {
                        // var jsonArray1 = [{'id':'','text': "doug"}];
                        this.modelList  = [{'id':'0','text': "Please select "+ e.target.value +" model " }].concat(response.data);
                        // console.log(this.modelList);
                    } else {
                        console.log('error');
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                });
            }
        },
     isData() {
            const plus = document.getElementsByClassName("plus");
            const minus = document.getElementsByClassName("minus");

            if (plus) {
                Array.prototype.forEach.call(plus, (e) => {
                e.addEventListener("click", (event) => {
                    let par = event.target.closest(".input-step");
                    par.getElementsByClassName("product-quantity")[0].value++;
                    // console.log('========');
                    // console.log(par.getElementsByClassName("product-quantity")[0].value);
                    this.quantityA = par.getElementsByClassName("product-quantity")[0].value;
                });
                });
            }

            if (minus) {
                Array.prototype.forEach.call(minus, (e) => {
                e.addEventListener("click", (event) => {
                    let par = event.target.closest(".input-step");
                    if (par.getElementsByClassName("product-quantity")[0].value > 0)
                    par.getElementsByClassName("product-quantity")[0].value--;
                    // console.log(par.getElementsByClassName("product-quantity")[0].value);
                    // console.log('********');
                    this.quantityA = par.getElementsByClassName("product-quantity")[0].value;
                });
                });
            }
        },

    getMyProfile(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'user/my')
        .then(response => {
            if (response) {
                this.ListUser = response.data;

                this.fullname = response.data.id;
                this.email = response.data.email;
                this.phonenumber = response.data.phone_number;
                this.Myreferal = response.data.referral_email;

                if(response.data.company_id){
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.get(process.env.VUE_APP_API_BASEURL+'company/view')
                    .then(response => {
                        if (response) {
                            this.compnyDetail = response.data;

                            this.company_name=response.data.name;
                            this.roc=response.data.roc;
                            this.address=response.data.address;
                            this.organization_id=response.data.organization_id;
                            this.organization=response.data.organization;

                            this.bankname=response.data.bank_acc_name;
                            this.accnumber=response.data.bank_acc_no;
                            this.ssm_location=response.data.ssm_location;

                        } else {
                            this.messageBag = ['No record.'];
                        }
                    })
                        .catch(error => {
                            this.messageBag = [error.error];
                    });
                }
            } else {
                this.messageBag = ['No record.'];
            }
        })
            .catch(error => {
                this.messageBag = [error.error];
        });
    },

        getEnquiries(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'enquiry/list/'+localStorage.getItem('userid'))
            .then(response => {
                if (response) {

                    if(response.data.status=='error'){
                        
                        this.messageBag = response.data.msj;
                        this.VoucherSeen = false;
                    }else{
                        this.EnquiryList = response.data;
                        this.VoucherSeen = false;
                    }
                    
                } else {
                    this.messageBag = ['No record.'];
                    this.VoucherSeen = false;
                }
               
                console.log("EnquiryList",this.EnquiryList);
            })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.VoucherSeen = false;
            });
        },

        getEnquiriesAdmin(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'enquiry/list')
            .then(response => {
                if (response) {
                console.log("Admin",response);
                    if(response.data.status=='error'){
                        
                        this.messageBag = response.data.msj;
                        this.VoucherSeenAdmin = false;
                    }else{
                        this.EnquiryListAdmin = response.data;
                        this.VoucherSeenAdmin = false;
                    }
                    
                } else {
                    this.messageBag = ['No record.'];
                    this.VoucherSeenAdmin = false;
                }
               
                // console.log("Voucherlist",this.VoucherList);
            })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.VoucherSeenAdmin = false;
            });
        },
        scrollTop(){
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        },

        CheckValisde(){
            if(!this.category){
                this.error_text_category='Please Select Category';
                this.error_show_category = true;
                this.scrollTop();
                this.proceedaxious = false;
                        
            }else{
                this.error_show_category = false;
            }
            
            if(!this.brand){
                this.error_text_brand='Please Select Brand';
                this.error_show_brand = true;
                this.scrollTop();
                this.proceedaxious = false;
            }else{
                this.error_show_brand = false;
            }
            
            if(!this.collection_address){
                this.error_text_address ='Please Fill Up Collection Address';
                this.error_show_address = true;
                this.scrollTop();
                this.proceedaxious = false;
            }else{
                this.error_show_address = false;
            }
            if(!this.appoinment_date){
                this.error_text_date='Please Select Preferred Appointment Date & Time';
                this.error_show_date = true;
                this.scrollTop();
                this.proceedaxious = false;
            }else{
                this.error_show_date = false;
            }

            if(!this.Images ){
                this.error_text_image='Please Upload Image';
                this.error_show_image = true;
                this.scrollTop();
                this.proceedaxious = false;
            }else{
                this.error_show_image = false;
            }

            if(this.model_ == 0){
                // this.error_text_model='Please Select Model';
                // this.error_show_model = true;
                // this.scrollTop();
                // this.proceedaxious = false;
            }else{
                this.error_show_model = false;
            }
        },
    AddEnquiry(){

        this.CheckValisde();
        if(this.proceedaxious === false){
//
        }else{
            // this.error_show_category = false;
            // this.error_show_brand = false;
            // this.error_show_address = false;
            // this.error_show_date = false;
            // this.error_show_image = false;

            const formData = new FormData();
                formData.append('category', this.category);
                formData.append('brand', this.brand);
                formData.append('model', this.model_);
                formData.append('quantity', this.quantityA);
                formData.append('address', this.collection_address);
                formData.append('uploadFile', this.Images);
                formData.append('uploadFile1', this.Images1);
                formData.append('uploadFile2', this.Images2);
                formData.append('appoinment_date', this.appoinment_date);
                formData.append('customer_id', this.fullname);
                formData.append('status', 0);
            const headers = { 'Content-Type': 'multipart/form-data' };
            this.isLoadingapi = true;
        
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
            axios.post(process.env.VUE_APP_API_BASEURL+'enquiry/add', formData, { headers })
            .then(response => {
                if (response) {
                    this.isLoadingapi = false;
                    this.getEnquiries();
                    // alert(response.data.msj);
                    
                    location.reload();
                }else{
                    console.log('tak ok');
                }
            });
        }
        
    },

    ApproveButton(){
            Swal.fire({
                title: "Are you sure you want to submit this enquiry?",
                // text: "You won't be able to revert!",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, Submit Order",
            }).then((result) => {
                if (result.value) {
                    this.loadsubmitOrder=true;
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.get(process.env.VUE_APP_API_BASEURL+'enquiry/list/submit/'+localStorage.getItem('userid'))
                    .then(response => {
                        // this.loadsubmitOrder=false;
                        console.log(response.data);
                        // if (response.data.status == 'successfully') {
                            Swal.fire({
                                title:"Enquiry Confirmed!", 
                                html: "Our customer service will contact you soon.", 
                                icon:"success",
                            })
                            this.getEnquiries();
                            this.loadsubmitOrder=false;
                        // }else{
           
                        //     Swal.fire("Fail!", "Your Enquiry Failed To Be Added. Please try again", "fail");
                        // }
                    });
                    this.ButtonSeen=false;
                }
            });
            // location.reload();
    },
    ClearButton(){
        // alert("Clear Inquiry?");
        // axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        // // axios.get(process.env.VUE_APP_API_BASEURL+'voucher/brand')
        // axios.post(process.env.VUE_APP_API_BASEURL+'enquiry/clear/'+localStorage.getItem('userid'))
        // .then(response => {
        //     if (response) {
        //         console.log('succes');
        //     } else {
        //         console.log('error');
        //     }
        // })
        //     .catch(error => {
        //         this.messageBag = [error.error];
        // });
        Swal.fire({
                title: "Are you sure you want to clear?",
                // text: "You won't be able to revert!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#34c38f",
                confirmButtonText: "Yes",
            }).then((result) => {
                if (result.value) {
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        
                    axios.post(process.env.VUE_APP_API_BASEURL+'enquiry/clear/'+localStorage.getItem('userid'))
                    .then(response => {
                        console.log(response.data);
                        // if (response.data.status == "successfully") {
                            Swal.fire("Cleared!", "Your data has been deleted.", "success").then(() => {
                                window.location.reload();
                            });
                            this.getEnquiries();
                        // }else if (response.data.status == "error") {
                        //     Swal.fire("Fail!", response.data.message, "fail");
                        // }else{
                        //     Swal.fire("Fail!", "Your order data fail to be deleted. Please try again later", "fail");
                        // }
                    });
                    
                }
            });
    },
    uploadFile() {
        this.isDisabled=false;
        this.Images = this.$refs.file.files[0];
        console.log("Images",this.Images);
    },
    uploadFile1() {
        this.isDisabled=false;
        this.Images1 = this.$refs.file1.files[0];
    },
    uploadFile2() {
        this.isDisabled=false;
        this.Images2 = this.$refs.file2.files[0];
    },

},
  components: {
    Layout,
    PageHeader,
    Select2,
    flatPickr,
    DataTable,
  },

  mounted() {
    this.getMyProfile();
    this.isData();
    this.getEnquiries();
    this.getEnquiriesAdmin();
    
},
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" /> 
    <span v-if="loadsubmitOrder">
        <div class="spinner-border text-success" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </span>
        <div id="myDIV" class="row" v-else>
            <div class="col-12" v-if="usercurrent != 'Admin'">
                <div class="card">
                    <div class="card-body">
                        <div class="container">
                                <div class="row justify-content-center mb-3">
                                    <div class="col-4">
                                        <label for="collection_address" class="form-label">Category<span class="text-danger">*</span></label>
                                    </div>
                                    <div class="col-6">
                                        <select v-model="category" class="form-select" @change="CategoryOnChangeSelected($event)" arial-label="Default select example" placeholder="Please Select Category" required>
                                            <option value="">Please Select Category</option>
                                            <option v-for="(itemad, indexda) in categoryList" :key="indexda" :value="itemad.text" >
                                                {{ itemad.text }}
                                            </option>
                                        </select>
                                        <span class="text-danger" v-if="error_show_category">{{this.error_text_category}}</span>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-3">
                                    <div class="col-4">
                                        <label for="collection_address" class="form-label">Brand<span class="text-danger">*</span></label>
                                    </div>
                                    <div class="col-6">
                                        <select v-model="brand" class="form-select" @change="ModelSelected($event)" arial-label="Default select example" placeholder="Please Select Brand" required>
                                            <option value="">Please Select Brand</option>
                                            <option v-for="(itemad, indexda) in brandList" :key="indexda" :value="itemad.text" >
                                                {{ itemad.text }}
                                            </option>
                                        </select>
                                        <span class="text-danger" v-if="error_show_brand">{{this.error_text_brand}}</span>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-4">
                                        <label for="collection_address" class="form-label">Model</label>

                                    </div>
                                    <div class="col-6">
                                        <Select2 class="js-example-basic-single js-states" v-model="model_" :options="modelList" v-on:change="ModelSelectedpID($event)" required></Select2>

                                    </div>
                                </div>
                                <div class="row justify-content-center pt-3">
                                    <div class="col-4">
                                        <label for="collection_address" class="form-label">Quantity<span class="text-danger">*</span></label>

                                    </div>
                                    <div class="col-6">
                                        <div class="input-step">
                                        <button type="button" class="minus">–</button>
                                        <input
                                            v-model="quantityA"
                                            type="number"
                                            class="product-quantity"
                                            min="1"
                                            max='1000'
                                            maxlength="4"
                                            width="100%"
                                            
                                        />
                                        <button type="button" class="plus">+</button>
                                    </div><br>
                                        <span class="text-danger" v-if="morethan">Maximun quantity is 1000</span>
                                    </div>
                                </div>
                                <div class="row justify-content-center pt-3">
                                    <div class="col-4">
                                        <label for="collection_address" class="form-label">Collection Address<span class="text-danger">*</span></label>

                                    </div>
                                    <div class="col-6">
                                        <textarea type="textarea" class="form-control" id="collection_address" v-model='collection_address' required></textarea>
                                    <span class="text-danger" v-if="error_show_address">{{this.error_text_address}}</span>
                                    </div>
                                </div>
                                <div class="row justify-content-center pt-3">
                                    <div class="col-4">
                                        <label for="preferred_appoinment_date" class="form-label">Preferred Appointment Date & Time<span class="text-danger">*</span></label>

                                    </div>
                                    <div class="col-6">
                                        <flatPickr type="number" v-model="appoinment_date" placeholder="Preferred Appointment Date & Time" :config="date" class="form-control" required></flatPickr>
                                        <span class="text-danger" v-if="error_show_date">{{this.error_text_date}}</span>
                                    </div>
                                </div>
                                <div class="row justify-content-center pt-3">
                                    <div class="col-4">
                                        <label for="enquiry" class="form-label">Upload Image <span class="text-danger">*</span><i v-b-tooltip.hover title="<img width=150 src='https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcTLKQgpKvS3pdpWZTPlYBwD_Knb1ZOdm_l-V6l5HDzcmC9ZXjOp' />" class="ri-information-fill"></i></label>

                                    </div>
                                    <div class="col-6">
                                        <input type="file" class="form-control" @change="uploadFile" ref="file" id="inputGroupFile04" aria-describedby="inputGroupFileAddon05" aria-label="Upload" required>
                                    <span class="text-danger" v-if="error_show_image">{{this.error_text_image}}</span>
                                    </div>
                                </div>
                                <div class="row justify-content-center pt-3">
                                    <div class="col-4">
                                        <label for="enquiry1" class="form-label">Upload Image 1</label>

                                    </div>
                                    <div class="col-6">
                                        <input v-b-tooltip.hover title="allow png,jpeg" type="file" class="form-control" @change="uploadFile1" ref="file1" id="inputGroupFile05" aria-describedby="inputGroupFileAddon05" aria-label="Upload1">
                                        <span v-if="ssm_location != ''">
                                            <!-- {{ ssm_location }} -->
                                        </span>
                                    </div>
                                </div>
                                <div class="row justify-content-center pt-3">
                                    <div class="col-4">
                                        <label for="enquiry2" class="form-label">Upload Image 2</label>

                                    </div>
                                    <div class="col-6">
                                        <input v-b-tooltip.hover title="allow png,jpeg" type="file" class="form-control" @change="uploadFile2" ref="file2" id="inputGroupFile06" aria-describedby="inputGroupFileAddon06" aria-label="Upload2">
                                        <span v-if="ssm_location != ''">
                                            <!-- {{ ssm_location }} -->
                                        </span>
                                    </div>
                                </div>

                                <div class="col-lg-12 pt-2">
                                    <div class="hstack gap-2 justify-content-end">
                                        <button type="submit" :disabled="isLoadingapi" @click="AddEnquiry" class="btn btn-primary">Add Item</button>
                                    </div>
                                </div>
                        </div>
                        <!-- <form @submit="AddEnquiry" id="AddEnquiry"> -->
                          
                        <!-- </form> -->
                    </div>
                </div>
            </div>

            <div class="col-lg-12" v-if="usercurrent != 'Admin'">
                <div class="card" v-if="EnquiryList.length > 0">
                    <div class="card-body">
                        <div class="table-responsive table-card">
                            <div v-if='VoucherSeen'>
                                <div class="spinner-bVoucher text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                
                                <DataTable class="table align-middle table-nowrap mb-0">
                                    <thead >
                                        <tr>
                                            <!-- <th scope="col">Device Name</th> -->
                                            <th scope="col">No</th>
                                            <th scope="col">Category</th>
                                            <th scope="col">Brand</th>
                                            <th scope="col">Model</th>
                                            <th scope="col">Quantity</th>
                                            <th scope="col">Collection Address</th>
                                            <th scope="col">Preferred Appointment Date</th>
                                            <th scope="col">Image</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in EnquiryList" :key="index" class="content">
                                            <!-- <td>{{item.device_name}}</td> -->
                                            <td>{{ index + 1 }}</td>
                                            <td>{{item.type}}</td>
                                            <td>{{item.brand}}</td>
                                            <td>{{item.device_name}}</td>
                                            <td>{{item.quantity}}</td>
                                            <td>{{item.address}}</td>
                                            <td>{{ format_date(item.appoinment_date)}}</td>
                                            <td>
                                                <a v-if="item.image1 != 'enquiry/cust/'" v-bind:href="cloudFrontURL+item.image1" target="_blank" rel="noreferrer noopener">View</a>
                                                <br>
                                                <a v-if="item.image2 != 'enquiry/cust/'" v-bind:href="cloudFrontURL+item.image2" target="_blank" rel="noreferrer noopener">View Image 1</a>
                                                <br>
                                                <a v-if="item.image3 != 'enquiry/cust/'" v-bind:href="cloudFrontURL+item.image3" target="_blank" rel="noreferrer noopener">View Image 2</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </DataTable>
                                <br><br><br>
                                <center>
                                    <button class="btn btn-outline-success waves-effect waves-light" @click="ApproveButton" type="button" > Submit </button> &nbsp;&nbsp;
                                    <button class="btn btn-outline-success waves-effect waves-light" @click="ClearButton" type="button"> Clear </button>
                                </center> 
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-12" v-if="usercurrent == 'Admin'">
                <div class="card">
                    <div class="card-body">
                        <div class="table-responsive table-card">
                            <div v-if='VoucherSeenAdmin'>
                                <div class="spinner-bVoucher text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                
                                <DataTable class="table align-middle table-nowrap mb-0">
                                    <thead >
                                        <tr>
                                            <th scope="col">Customer Name</th>
                                            <th scope="col">Email</th>
                                            <!-- <th scope="col">Collection Address</th>
                                            <th scope="col">Preferred Appointment Date</th> -->
                                            <th scope="col">Action</th>
                                            <!-- <th scope="col">Quantity</th> -->
                                            <!-- <th scope="col">Name</th>
                                            <th scope="col">Image1</th>
                                            <th scope="col">Image2</th>
                                            <th scope="col">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in EnquiryListAdmin" :key="index" class="content">
                                            <td>{{item.name}}</td>
                                            <td>{{item.email}}</td>
                                            <!-- <td>{{item.address}}</td>
                                            <td>{{item.appoinment_date}}</td> -->
                                            <td><router-link :to="'/enquiry/cust/'+item.id">View</router-link></td>
                                            <!-- <td>{{item.quantity}}</td>
                                            <td><a v-bind:href="cloudFrontURL+item.upload_file" target="_blank" rel="noreferrer noopener">Click Here to View</a></td>
                                            <td><a v-bind:href="cloudFrontURL+item.upload_file2" target="_blank" rel="noreferrer noopener">Click Here to View</a></td>
                                            <td><a v-bind:href="cloudFrontURL+item.upload_file3" target="_blank" rel="noreferrer noopener">Click Here to View</a></td> -->
                                            <!-- <td> 
                                                <button @click="close_enquiry(item.EnquiryId)" type="submit" class="btn btn-primary">Close</button>
                                            </td> -->
                                        </tr>
                                    </tbody>
                                </DataTable>
                                <br><br><br>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </Layout>

</template>